(function ($) {
  var breakPointLg = 1200,
  breakPointMd = 768,
  breakPointSm = 480;

  function addHyphenClass(){
    if ($(window).width() < breakPointMd) {
      $('table').addClass('hyphenate');
      $('table td:not(.head) .zahl').addClass('donthyphenate');
    }
  }

  function provideHyphenation(hyphenate, c) {
    $(c).each(function(){
      var content = $(this).text();
      $(this).text(hyphenate(content));
    });
  }

  // addHyphenClass();

  // $(document).on('noteLoaded', function () {
  //   addHyphenClass();
  //   provideHyphenation(createHyphenator(hyphenationPatternsDeCh), '.nhsnote__content .hyphenate span:not(.donthyphenate)');
  // });
  
  $(document).on('tablesDone', function(){
    addHyphenClass();
    provideHyphenation(createHyphenator(hyphenationPatternsDeCh), '.hyphenate .fixed span:not(.donthyphenate)');
    provideHyphenation(createHyphenator(hyphenationPatternsDeCh), '.nosplit .hyphenate tr td:first-child span:not(.donthyphenate)');
  });

})(jQuery);
